<div class="rectangle {{statusClass()}}">
	<span class="status-text">{{getStatusText()}}</span>
</div>
